import React from 'react';
import "./onboard-miles-smiles-card-style.scss";
import {useTranslation} from "react-i18next";
import IconCLSC from './images/CLSC.png';
import IconCLPL from './images/CLPL.png';
import IconELIT from './images/ELIT.png';
import IconELPL from './images/ELPL.png';
import {getMilesOrMil} from "../../../util/Currency";

const OnboardMilesSmilesCard = (props) => {
    const {t, i18n} = useTranslation();
    const {mil, fullname, memberId, cardType} = props;

    const getCardType = () => {
        if (cardType === 'CLSC') return IconCLSC;
        if (cardType === 'CLPL') return IconCLPL;
        if (cardType === 'ELIT') return IconELIT;
        if (cardType === 'ELPL') return IconELPL;
        return IconCLSC;
    }

    return (
        <div className="onboard-miles-smiles-card-root">
            <img alt="CardType" className="onboard-miles-smiles-card-img" src={getCardType()}/>
            <div className="onboard-miles-smiles-card-row">
                <div>
                    <p className="onboard-miles-smiles-card-title">{t('payment.account_miles')}</p>
                    {mil && (<p className="onboard-miles-smiles-card-mile">{mil + getMilesOrMil(i18n, mil)}</p>)}
                    {!mil && (<p className="onboard-miles-smiles-card-error">{t('payment.remaining_miles_error')}</p>)}
                </div>
                <div>
                    {mil && (<p className="onboard-miles-smiles-card-info">{fullname}</p>)}
                    {mil && (<p className="onboard-miles-smiles-card-info">{memberId}</p>)}
                </div>
            </div>
        </div>
    )
};

export default OnboardMilesSmilesCard;
